/**
 * Referenzdaten, die alle drei Seiten des Moduls Genehmigung brauchen.
 *
 * Nachweisarten, Bearbeitungswege, Nachweiskatalog, Baustein-Typen und die Nutzer der Organisation hängen an keinem
 * Antrag – sie
 * werden auf den Antrags-, Nachweis- und Kostenseiten gleichermaßen für die Anzeige, das Anlegen
 * und das Nachweis-Detail gebraucht. Ohne diesen Hook stünde dieselbe Ladung dreimal im Code.
 */
import { useCallback, useEffect, useState } from "react";
import { permitsApi } from "../../../../services/api/permits";
import { usersApi, OrgUser } from "../../../../services/api/users";
import { parseApiError } from "../../../../services/api/errorPresentation";
import {
  ApplicationComponentTypeOption,
  EvidenceCatalogOption,
  EvidenceTypeOption,
  ProcessingPathOption,
} from "../../../../types";

export function usePermitLookups() {
  const [evidenceTypeOptions, setEvidenceTypeOptions] = useState<
    EvidenceTypeOption[]
  >([]);
  const [processingPathOptions, setProcessingPathOptions] = useState<
    ProcessingPathOption[]
  >([]);
  const [nachweisKatalog, setNachweisKatalog] = useState<
    EvidenceCatalogOption[]
  >([]);
  const [componentTypeOptions, setComponentTypeOptions] = useState<
    ApplicationComponentTypeOption[]
  >([]);
  const [orgUsers, setOrgUsers] = useState<OrgUser[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [evidenceTypes, paths, katalog, componentTypes, users] =
        await Promise.all([
          permitsApi.getEvidenceTypeOptions(),
          permitsApi.getProcessingPathOptions(),
          permitsApi.getEvidenceCatalogOptions(),
          permitsApi.getApplicationComponentTypeOptions(),
          usersApi.getOrgUsers(),
        ]);
      setEvidenceTypeOptions(evidenceTypes ?? []);
      setProcessingPathOptions(paths ?? []);
      setNachweisKatalog(katalog ?? []);
      setComponentTypeOptions(componentTypes ?? []);
      setOrgUsers(users ?? []);
    } catch (err) {
      setError(parseApiError(err).message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    evidenceTypeOptions,
    processingPathOptions,
    nachweisKatalog,
    componentTypeOptions,
    orgUsers,
    loading,
    error,
  };
}
